import { useState, useEffect, useRef } from "react"

type Props = {
  onSchedule:         () => void
  onDraft:            () => void
  onPublishNow:       () => void
  scheduleDisabled:   boolean
  draftDisabled:      boolean
  publishNowDisabled: boolean
  scheduleLoading:    boolean
  draftLoading:       boolean
  publishNowLoading:  boolean
}

const SplitButton = ({
  onSchedule, onDraft, onPublishNow,
  scheduleDisabled, draftDisabled, publishNowDisabled,
  scheduleLoading, draftLoading, publishNowLoading,
}: Props) => {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const handle = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener("mousedown", handle)
    return () => document.removeEventListener("mousedown", handle)
  }, [open])

  const isLoading = scheduleLoading || draftLoading || publishNowLoading

  return (
    <div className="ps-split-btn" ref={ref}>
      <button
        className="ps-split-btn__main"
        type="button"
        onClick={onSchedule}
        disabled={scheduleDisabled || isLoading}
      >
        {scheduleLoading ? "送信中..." : "予約投稿"}
      </button>
      <button
        className="ps-split-btn__arrow"
        type="button"
        onClick={() => setOpen(o => !o)}
        disabled={isLoading}
        aria-label="その他の投稿操作"
      >
        <i className="bi bi-chevron-down" />
      </button>

      {open && (
        <div className="ps-split-btn__dropdown">
          <button
            className="ps-split-btn__item"
            type="button"
            onClick={() => { setOpen(false); onDraft() }}
            disabled={draftDisabled}
          >
            <i className="bi bi-floppy" />
            下書き保存
          </button>
          <button
            className="ps-split-btn__item"
            type="button"
            onClick={() => { setOpen(false); onPublishNow() }}
            disabled={publishNowDisabled}
          >
            <i className="bi bi-send" />
            今すぐ投稿
          </button>
        </div>
      )}
    </div>
  )
}

export default SplitButton
